import React from 'react';
import { AccountSummaryCounts } from '../../../../types/accounting';

interface AccountsSummaryCardsProps {
  summary: AccountSummaryCounts;
}

function SummaryCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4">
      <p className="text-sm font-medium text-gray-600">{label}</p>
      <p className="mt-3 text-3xl font-semibold text-black">{value}</p>
    </div>
  );
}

export function AccountsSummaryCards({ summary }: AccountsSummaryCardsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-4">
      <SummaryCard label="Accounts" value={summary.totalAccounts} />
      <SummaryCard label="Assets" value={summary.assetAccounts} />
      <SummaryCard label="Liabilities" value={summary.liabilityAccounts} />
      <SummaryCard label="Revenue" value={summary.revenueAccounts} />
    </div>
  );
}
